import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Branches from "../pages/branchs/Branches";
import { ManiSliderLinks } from "../../common/Links/mainSliderLinks";
import Settings from "../pages/Settings/Settings";
import { userTypes } from "../../enums/usersTpes";
import Sidebar from "../SiderLayout/SiderBar";
import MobileNav from "../SiderLayout/MobileNav";
import Users from "../pages/users/Users";
import Customers from "../pages/customers/Customers";
import Logs from "../Logs/Logs";
import Notifications from "../Notifications/Notifications";
import SocialMedia from "../SocialMedia/SocialMedia";
import Copuns from "../Coupons/Copuns";
import NotFound from "../pages/NotFound/NotFound";

const MainLayout = (props) => {
  const mainLinks = ManiSliderLinks();
  const per = localStorage.getItem("role");

  // Filter main links based on user permissions
  const mainLinksFilter = mainLinks.filter((link) => {
    // If user is not admin, filter out admin-only items
    if (per !== userTypes.ADMIN) {
      // Filter out main admin items
      if (link.admin) {
        return false;
      }

      // Filter submenu items that require admin
      if (link.submenu) {
        const filteredSubmenu = link.submenu.filter((subItem) => {
          return !subItem.admin || per === userTypes.ADMIN;
        });

        // Only show main item if it has visible submenu items
        return filteredSubmenu.length > 0;
      }
    }

    return true;
  });

  return (
    <div className="flex flex-col min-h-screen w-full md:grid grid-cols-[220px_1fr] lg:grid-cols-[280px_1fr]">
      <div className="md:sticky md:top-0 md:self-start">
        <Sidebar siderLinks={mainLinksFilter} />
        <MobileNav siderLinks={mainLinksFilter} />
      </div>

      <div className="p-5 bg-backgroundConant min-h-screen flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<Navigate to="/branches" replace />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users-activity" element={<Logs />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/social-media" element={<SocialMedia />} />
          <Route path="/copuns" element={<Copuns />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
};

export default MainLayout;
